import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../lib/firebase';

export const storageService = {
  async uploadFile(file: File, projectId: string, onProgress?: (progress: number) => void): Promise<string> {
    const safeName = file.name.replace(/[^\w.\-()+ ]+/g, '_');
    const storageRef = ref(storage, `projects/${projectId}/releases/${Date.now()}_${safeName}`);

    return new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(storageRef, file, {
        contentDisposition: `attachment; filename="${safeName}"`,
      });
      uploadTask.on(
        'state_changed',
        (snapshot) => onProgress?.((snapshot.bytesTransferred / snapshot.totalBytes) * 100),
        reject,
        async () => {
          try {
            resolve(await getDownloadURL(uploadTask.snapshot.ref));
          } catch (error) {
            reject(error);
          }
        }
      );
    });
  },

  /** Deletes a stored file by its download URL. Missing files are ignored. */
  async deleteFile(fileUrl: string): Promise<void> {
    try {
      await deleteObject(ref(storage, fileUrl));
    } catch (error: any) {
      if (error?.code !== 'storage/object-not-found') throw error;
    }
  },
};
